export default __webpack_public_path__ + "static/media/texp8.4676ad98.png";